export default "__VITE_ASSET__TTawbFTC__"